/** As we receive too much dots from backend and we need to display only 30 dots for daily charts and playlists and 52 dots for weekly charts, the redundant old data should be cut off */

const getValidChartDotsNumber = (data: any, dotsNumber = 30): any => {
  if (!data || data.length < 1) return;
  return data.slice(-dotsNumber);
};

export default getValidChartDotsNumber;
